import { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const BuildingContext = createContext({
  buildings: [],
  activeBuilding: 'all',
  setActiveBuilding: () => {},
  refresh: () => {},
});

const STORAGE_KEY = 'active_building';

export function BuildingProvider({ children }) {
  const [buildings, setBuildings] = useState([]);
  const [activeBuilding, setActiveBuildingState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || 'all'; } catch { return 'all'; }
  });

  const setActiveBuilding = (val) => {
    setActiveBuildingState(val);
    try { localStorage.setItem(STORAGE_KEY, val); } catch {}
  };

  const fetchBuildings = async () => {
    try {
      const res = await api.get('/admin/buildings');
      setBuildings(res.data);
    } catch { /* non-admin users can ignore */ }
  };

  useEffect(() => { fetchBuildings(); }, []);

  return (
    <BuildingContext.Provider value={{ buildings, activeBuilding, setActiveBuilding, refresh: fetchBuildings }}>
      {children}
    </BuildingContext.Provider>
  );
}

export const useBuilding = () => useContext(BuildingContext);
